export default function Algorithms() {
  return <div>Algorithms</div>;
}
